import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import makeStyles from "@material-ui/core/styles/makeStyles"
import TextField from "@material-ui/core/TextField"
import Button from "@material-ui/core/Button"
import AddIcon from "@material-ui/icons/Add"
import SweetAlert from "react-bootstrap-sweetalert"
import React, { Fragment, useContext, useState } from "react"
import ReactDOM from "react-dom"
import { ColorResult, TwitterPicker } from "react-color"
import { useStyles as useAlertStyles } from "Components/Alert"
import { AppContext } from "../Home/context"
import { ArticleType } from "Types/article"
import { InitialModal } from "Methods/modal"
import { InitialArticleType } from "Methods/article"

const useStyles = makeStyles({
    ColorBlock: {
        width: "40px",
        height: "15px",
        borderRadius: 4,
        backgroundColor: "red",
        margin: "20px 0",
    },
    btnGroup: {
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
    },
})

interface ComponentProps {
    onRowAdd: (newData: any) => Promise<void>
}

const ArticleTypeAdd = (props: ComponentProps) => {
    const { onRowAdd } = props
    const classes = useStyles()
    const alertClasses = useAlertStyles()
    const [ show, setShow ] = useState<boolean>(false)
    const [ articleType, setArticleType ] = useState<ArticleType>(InitialArticleType)
    const { handleChangeModal } = useContext(AppContext)
    const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setArticleType({
            ...articleType,
            name: event.target.value,
            type_name: event.target.value,
        })
    }
    const handleColorChange = (color: ColorResult) => {
        setArticleType({
            ...articleType,
            color_code: color.hex,
        })
    }
    const handleAddArticleType = () => {
        setShow(true)
    }
    const handleCancel = () => {
        setArticleType(InitialArticleType)
        setShow(false)
    }
    const handleConfirm = async () => {
        delete articleType.id
        await onRowAdd(articleType)
        setArticleType(InitialArticleType)
        setShow(false)
        handleChangeModal({
            show: true,
            type: "success",
            title: "已添加！",
            timeout: 800,
            onConfirm: () => {
                handleChangeModal(InitialModal)
            },
        })
    }
    const el: HTMLElement | null = document.querySelector("#beauty_article_type_modal")
    const disabled = articleType.name === ""
    return (
        <Fragment>
            <IconButton onClick={handleAddArticleType}>
                <AddIcon />
            </IconButton>
            {
                el && ReactDOM.createPortal(
                    <SweetAlert
                        type="default"
                        title="添加文章类型"
                        confirmBtnText="确定"
                        cancelBtnText="取消"
                        disabled={disabled}
                        onConfirm={handleConfirm}
                        customButtons={
                            <div className={classes.btnGroup}>
                                <Button variant="contained" onClick={handleCancel} className={alertClasses.cancelBtn}>
                                    取消
                                </Button>
                                <Button
                                    disabled={disabled}
                                    variant="contained"
                                    className={alertClasses.confirmBtn}
                                    onClick={handleConfirm}
                                >
                                    确定
                                </Button>
                            </div>
                        }
                        show={show}
                    >
                        <Grid container direction="column" justify="center">
                            <TextField label="文章类型" value={articleType.name} onChange={handleTextChange}/>
                            <Grid item>
                                <div
                                    className={classes.ColorBlock}
                                    style={{backgroundColor: `${articleType.color_code}`}}
                                />
                            </Grid>
                            <Grid item>
                                <TwitterPicker
                                    color={articleType.color_code}
                                    width="100%"
                                    onChange={handleColorChange}
                                />
                            </Grid>
                        </Grid>
                    </SweetAlert>,
                    el,
                )
            }
        </Fragment>
    )
}

export default ArticleTypeAdd
